module.exports = __webpack_public_path__ + "img/20200623-1.fdc46eef.jpg";